import React from 'react';
import { Gift, Lock, Clock, Leaf } from 'lucide-react';
import { publicProspectPageConfig } from '../../config/publicProspectPageConfig';
import PropertyMap from './PropertyMap';

const ICONS = { gift: Gift, lock: Lock, clock: Clock, leaf: Leaf };

export default function PropertyHero({
  property,
  copy,
  language,
  onDiscover,
  disabled,
  compact = false,
}) {
  const address = [property?.address, property?.city].filter(Boolean).join(', ');
  const addressLine = address || property?.address || '';

  return (
    <section className={`grid gap-6 ${compact ? '' : 'lg:grid-cols-2 lg:items-start'}`}>
      <div className="space-y-4">
        <div className="h-0.5 w-16 bg-[#c4a574]" aria-hidden="true" />
        <h1 className="prospect-display text-[1.9rem] font-semibold leading-[1.08] tracking-tight text-[#0B1F2A] sm:text-[2rem] lg:text-[2.25rem]">
          <span className="block">{copy.heroPrefix}</span>
          <span className="block">{addressLine}</span>
        </h1>
        {compact ? (
          <PropertyMap
            property={property}
            title={copy.mapTitle}
            fallbackLabel={copy.mapFallback}
            retryLabel={copy.mapRetry}
          />
        ) : null}
        <h2 className="prospect-display text-[1.875rem] font-semibold leading-[1.08] tracking-tight text-[#0B1F2A] sm:text-[1.95rem]">
          {copy.heroHeadline}
        </h2>
        <p className="prospect-ui max-w-xl text-[1.0625rem] leading-relaxed text-[#1f4a52]">{copy.heroBody}</p>
        <button
          type="button"
          disabled={disabled}
          onClick={onDiscover}
          className="prospect-ui inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#004747] px-5 py-3 text-[1.0625rem] font-bold text-white hover:bg-[#003636] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#007c91] focus-visible:ring-offset-2 disabled:opacity-60 sm:w-auto"
        >
          {copy.heroCta}
          <span aria-hidden="true">→</span>
        </button>
        <TrustIndicators language={language} />
      </div>
      {!compact ? (
        <PropertyMap
          property={property}
          title={copy.mapTitle}
          fallbackLabel={copy.mapFallback}
          retryLabel={copy.mapRetry}
        />
      ) : null}
    </section>
  );
}

export function TrustIndicators({ language }) {
  return (
    <ul className="mx-auto grid w-full max-w-md grid-cols-2 justify-items-center gap-x-4 gap-y-3 text-sm text-[#1f4a52] sm:flex sm:max-w-none sm:flex-wrap sm:items-center sm:justify-center sm:gap-x-5">
      {publicProspectPageConfig.trustIndicators.map((item) => {
        const Icon = ICONS[item.icon] || Gift;
        return (
          <li key={item.id} className="prospect-ui flex items-center justify-center gap-2">
            <Icon className="h-4 w-4 shrink-0" aria-hidden="true" />
            <span>{language === 'en' ? item.en : item.fr}</span>
          </li>
        );
      })}
    </ul>
  );
}
